import { FontSizes } from "../assets/fonts/fontSizes";
import { Colors } from "../utils/colors";
import { Fonts } from "../utils/fonts";

type Props = {
  placeholder?: string;
  value?: string;
  onChangeText?: (value: string) => void;
  keyboardType?: "default" | "email-address" | "numeric";
};

export default function Input({
  placeholder,
  value,
  onChangeText,
  keyboardType = "default",
}: Props) {
  const getType = () => {
    if (keyboardType === "email-address") return "email";
    if (keyboardType === "numeric") return "number";
    return "text";
  };

  return (
    <div style={styles.inputContainer}>
      <input
        style={styles.input}
        value={value}
        placeholder={placeholder}
        type={getType()}
        onChange={(e) => onChangeText?.(e.target.value)}
      />
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  inputContainer: {
    height: 40,
    width: 300,
    marginBottom: 20,
    borderRadius: 10,
    padding: "0 10px",
    border: `1px solid ${Colors.Black}`,
    display: "flex",
    alignItems: "center",
  },
  input: {
    width: "100%",
    height: "100%",
    border: "none",
    outline: "none",
    fontSize: FontSizes.sm,
    fontWeight: Fonts.Light,
    color: Colors.Black,
    backgroundColor: "transparent",
    fontFamily: "Inter",
  },
};

//Add to index.css:
// input::placeholder {
//   color: #000000;
//   opacity: 0.6;
// }
